document.addEventListener('DOMContentLoaded', function () {
	const modalForm = document.getElementById('application-popup__form') as HTMLFormElement | null;
	const btn = document.getElementById('upload-btn') as HTMLButtonElement | null;
	const input = document.getElementById('file-upload') as HTMLInputElement | null;
	const fileListEl = document.getElementById('file-list') as HTMLElement | null;
	const fileErrorEl = document.getElementById('file-errors') as HTMLElement | null;
	let selectedFiles: File[] = [];

	// Popup Elemente
	const stickyButton = document.querySelector('.stickybutton') as HTMLButtonElement | null;
	const overlay = document.getElementById('application-overlay') as HTMLElement | null;
	const popup = document.getElementById('application-popup') as HTMLElement | null;
	const closeBtn = popup?.querySelector('.application-popup__close') as HTMLButtonElement | null;

	// Sticky Button öffnet Popup + Overlay
	if (stickyButton && popup && overlay) {
		stickyButton.addEventListener('click', () => {
			popup.style.display = 'block';
			overlay!.style.display = 'block';
			// Kein overflow: hidden -> Scroll bleibt aktiv
		});
	}

	// Close Button schließt Popup + Overlay
	if (closeBtn && popup && overlay) {
		closeBtn.addEventListener('click', () => {
			popup.style.display = 'none';
			overlay!.style.display = 'none';
			// Kein overflow zurücksetzen nötig
		});
	}

	// Klick auf Overlay schließt Popup
	overlay?.addEventListener('click', () => {
		popup!.style.display = 'none';
		overlay!.style.display = 'none';
	});

	// Optional: Klick außerhalb des Formulars
	popup?.addEventListener('click', (e: MouseEvent) => {
		if (e.target === popup) {
			popup.style.display = 'none';
			overlay!.style.display = 'none';
			document.body.style.overflow = '';
		}
	});

	// Upload-Button
	if (btn && input) {
		btn.addEventListener('click', function () {
			input.click();
		});

		input.addEventListener('change', function (e: Event) {
			const target = e.target as HTMLInputElement;
			const newFiles = target.files ? Array.from(target.files) : [];
			const maxFiles = 3;
			const maxSize = 20 * 1024 * 1024;
			const allowed = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];
			const validFiles: File[] = [];
			const invalidFiles: { name: string; error: string }[] = [];

			for (const file of newFiles) {
				if (selectedFiles.length + validFiles.length >= maxFiles) {
					invalidFiles.push({
						name: file.name,
						error: `Es dürfen insgesamt nur ${maxFiles} Dateien hochgeladen werden.`,
					});
					continue;
				}

				const ext = file.name.split('.').pop()?.toLowerCase() || '';
				if (!allowed.includes(ext)) {
					invalidFiles.push({
						name: file.name,
						error: 'Dateiformat nicht erlaubt.',
					});
				} else if (file.size > maxSize) {
					invalidFiles.push({
						name: file.name,
						error: 'Die Datei überschreitet die maximale Größe von 20 MB. Bitte laden Sie eine kleinere Datei hoch.',
					});
				} else {
					validFiles.push(file);
				}
			}

			selectedFiles = [...selectedFiles, ...validFiles];
			updateFileList();
			renderFileErrors(invalidFiles);
			input.value = '';
		});
	}

	function updateFileList() {
		if (!fileListEl || !input) { return; }

		fileListEl.innerHTML = '';
		const dataTransfer = new DataTransfer();

		selectedFiles.forEach((file, index) => {
			dataTransfer.items.add(file);

			const fileItem = document.createElement('div');
			fileItem.className = 'file-item';
			fileItem.innerHTML = `
			<div class="file-item__top">
				<span class="file-icon success-icon" aria-hidden="true">✔️</span>
				<span class="file-name">${file.name}</span>
				<span class="remove-file" data-index="${index}" title="Entfernen">✖️</span>
			</div>
		`;
			fileListEl.appendChild(fileItem);
		});

		input.files = dataTransfer.files;

		// Remove-Event korrekt binden
		const removeButtons = fileListEl.querySelectorAll('.remove-file');
		removeButtons.forEach((btn) => {
			btn.addEventListener('click', () => {
				const index = parseInt(btn.getAttribute('data-index') || '0', 10);
				selectedFiles.splice(index, 1);
				updateFileList(); // nach Änderung erneut aufrufen
			});
		});
	}

	function renderFileErrors(errors: { name: string; error: string }[]) {
		if (!fileErrorEl) {
			return;
		}
		fileErrorEl.innerHTML = '';

		errors.forEach((err) => {
			const errorItem = document.createElement('div');
			errorItem.className = 'file-item error';
			errorItem.innerHTML = `
				<span class="file-icon error-icon" aria-hidden="true">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M11.5 15.6V4.5H12.5V15.6H11.5ZM11.5 19.5V18.49H12.5V19.5H11.5Z" fill="#8E002B"/></svg>
				</span>
				<div class="file-item__left">
					<span class="file-name">${err.name || 'Unbekannte Datei'}</span>
					<div class="file-error">${err.error}</div>
				</div>
				<span class="remove-error" title="Entfernen">
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 13L1 1M13 1L1 13" stroke="#8E002B" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</span>
			`;

			const removeBtn = errorItem.querySelector('.remove-error');
			removeBtn?.addEventListener('click', () => errorItem.remove());
			fileErrorEl.appendChild(errorItem);
		});
	}

	if (modalForm) {
		modalForm.addEventListener('submit', async (event: SubmitEvent) => {
			event.preventDefault();
			const url = modalForm.dataset.url;
			if (!url) {
				return;
			}

			const inputs = modalForm.querySelectorAll('input, textarea, select');
			const fields: Record<string, string> = {};

			inputs.forEach((input) => {
				const el = input as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
				if (el.name && el.value) {
					fields[el.name] = el.value;
				}
			});

			try {
				const response = await sendAsyncMail(url, fields);
				const successMessage = document.querySelector('.application-popup__success') as HTMLElement | null;
				const errorElement = modalForm.querySelector('.application-popup__error') as HTMLElement | null;

				if (response.success && successMessage) {
					modalForm.style.display = 'none';
					successMessage.style.display = 'block';
				} else if (errorElement) {
					errorElement.innerText = 'Beim Senden der Nachricht ist ein Fehler aufgetreten.';
				}
			} catch {
				const errorElement = modalForm.querySelector('.application-popup__error') as HTMLElement | null;
				if (errorElement) {
					errorElement.innerText = 'Beim Senden der Nachricht ist ein Fehler aufgetreten.';
				}
			}
		});
	}
});

export async function sendAsyncMail(url: string, fields: Record<string, string>): Promise<{ success: boolean }> {
	const response = await fetch(url, {
		method: 'POST',
		body: JSON.stringify({ fields }),
		headers: { 'Content-Type': 'application/json' },
	});
	return response.json();
}
